enum IProgressType {
	Line = 'line',
	Circle = 'circle',
	Dashboard = 'dashboard'
}

export default IProgressType;
